import React from 'react';
import MyGoals from '../Dashboard/MyGoals/MyGoals';
import { demoGoals } from './marketingDemoData';
import '../Dashboard/MyGoals/MyGoals.css';

/** Production My Goals with fictional demo data — marketing only. */
const MarketingProductionGoals = () => (
    <MyGoals
        marketingPreview={{ inProgress: demoGoals }}
        getMyProgress={() => {}}
        getMyAchiements={() => {}}
    />
);

export default MarketingProductionGoals;
